module.exports = __webpack_public_path__ + "img/sort-icon.03b9c3b9.svg";